/** 首页路由 */
export default[
    {
        path:'/',
        meta: {title: '概览'},
        name:'index',
        component: ()=>import('@/pages/index/index.vue')
    }
]
